var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.692 14c-.4 0-.67-.134-.937-.398L.402 8.3c-.536-.53-.536-1.325 0-1.855a1.3 1.3 0 0 1 1.874 0l4.283 4.241 7.093-8.216c.534-.53 1.338-.663 1.873-.132.536.53.67 1.325.134 1.855L7.63 13.47c-.401.396-.536.53-.937.53"
  })));
};
export default SvgIconCheck;